<app-project-views-list
    fxFlex
    fxLayoutAlign="end center"
    fxLayoutAlign.md="start center"
    [allViews]="allViews$ | async"
    [activeViewId]="activeViewId$ | async"
    [config]="config"
    (onEditProjectView)="editProjectView($event)"
    (onProjectViewChange)="projectViewChange($event)"
></app-project-views-list>
